import { withInstall as t } from "../../utils/with-install.js";
import o from "./button.vue.js";
/* empty css            */
const p = t(o);
export {
  p as ApButton,
  p as default
};
